package com.ijoin.data.api

import com.ijoin.data.api.ApiClient.addAuthToken
import com.ijoin.data.model.PushPlatform
import com.ijoin.data.model.PushTokenRequest
import io.ktor.client.request.delete
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.client.request.url
import io.ktor.http.ContentType
import io.ktor.http.contentType

class PushTokenApi {
    private val client = ApiClient.client
    private val baseUrl = "${ApiClient.getBaseUrl()}/api/push-tokens"

    suspend fun registerToken(
        token: String,
        platform: PushPlatform,
        deviceName: String? = null,
    ): Result<Unit> {
        return safeApiCall {
            client.post(baseUrl) {
                addAuthToken()
                contentType(ContentType.Application.Json)
                setBody(PushTokenRequest(token = token, platform = platform, deviceName = deviceName))
            }
        }.map { }
    }

    suspend fun deleteToken(token: String): Result<Unit> {
        return safeApiCall {
            client.delete(baseUrl) {
                addAuthToken()
                url {
                    parameters.append("token", token)
                }
            }
        }.map { }
    }
}
